// removed by extract-text-webpack-plugin
module.exports = {"header":"Desktop__header__17WAK","headings":"Desktop__headings__2nfcH","row":"Desktop__row__Ry0Gv","checkmark":"Desktop__checkmark__10srg","info":"Desktop__info__S_lo1","footnote":"Desktop__footnote__3vui6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SuiteKey/Options/BenefitsContent/Desktop/Desktop.scss
// module id = 426
// module chunks = 0